import apiClient from './apiClient';

const API_CATPASS_URL = import.meta.env.VITE_API_CATPASS_URL;

export const slugifyProducerName = (value = "") =>
    String(value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

const normalizeProducer = (producer, source) => {
    const identifier =
        producer.organizador_id ??
        producer.id ??
        producer.name ??
        producer.contactEmail ??
        `${source}-producer`;

    return {
        ...producer,
        source,
        uniqueId: `${source}-${identifier}`,
    };
};

export const getProducers = async () => {
    try {
        const requests = [apiClient.get("/producer")];

        if (API_CATPASS_URL) {
            requests.push(
                apiClient.get(`${API_CATPASS_URL.replace(/\/$/, "")}/producer`)
            );
        }

        const [passeventResult, catpassResult] = await Promise.allSettled(
            requests
        );

        const passeventProducers =
            passeventResult.status === "fulfilled"
                ? (passeventResult.value.data || []).map((producer) =>
                      normalizeProducer(producer, "passevent")
                  )
                : [];

        const catpassProducers =
            catpassResult?.status === "fulfilled"
                ? (catpassResult.value.data || []).map((producer) =>
                      normalizeProducer(producer, "catpass")
                  )
                : [];

        const producers = [...passeventProducers, ...catpassProducers].sort(
            (a, b) => (a?.name || "").localeCompare(b?.name || "", "es", { sensitivity: "base" })
        );

        if (producers.length > 0) {
            return producers;
        }

        const passeventError =
            passeventResult.status === "rejected" ? passeventResult.reason : null;
        const catpassError =
            catpassResult?.status === "rejected" ? catpassResult.reason : null;

        if (passeventError || catpassError) {
            throw passeventError || catpassError;
        }

        return [];
    } catch (error) {
        console.log(error);
        throw new Error(
            error?.response?.data?.error || error?.message || "No se pudieron cargar las productoras"
        );
    }
};

export const getProducerProfile = async (producerSlug) => {
    try {
        const response = await apiClient.get(
            `/producer/public/${encodeURIComponent(producerSlug)}`
        );
        return response.data;
    } catch (error) {
        console.log(error);
        throw new Error(
            error?.response?.data?.error ||
                error?.message ||
                "No se pudo cargar la productora"
        );
    }
};
